




































































































import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import PoiRightPie from './poi-right-pie.vue';
import PoiStackArea from './poi-right-stack-area.vue'
import PoiArea from './poi-right-area.vue';
import PoiPictorialBar from './poi-right-pictorialBar.vue';
import SearchStore from '@/store/SearchStore.brain';
import DetailStore from '@/store/DetailStore';
import lang2d from '../../../utils/lang/lang-2d.js';

import qsObj from '@/utils/qs';

@Component({
    components: {PoiRightPie, PoiStackArea, PoiArea, PoiPictorialBar}
})
export default class PoiRight extends Vue {
    animationBaseInfo = autoAnimation ? 'fly-out': 'fly-in';
    animationEmotionEvaluate = autoAnimation ? 'fly-out': 'fly-in';
    animationEmotionPos = autoAnimation ? 'fly-out': 'fly-in';
    animationEmotionMid = autoAnimation ? 'fly-out': 'fly-in';
    animationEmotionNeg = autoAnimation ? 'fly-out': 'fly-in';
    animationEmotionAnalyze = autoAnimation ? 'fly-out': 'fly-in';
    animationCommentCount = autoAnimation ? 'fly-out': 'fly-in';
    animationSamePoi = autoAnimation ? 'fly-out': 'fly-in';
    animationSimilar = autoAnimation ? 'fly-out': 'fly-in';
    animationSentimentAnalysis = autoAnimation ? 'fly-out': 'fly-in';
    lang:any = lang2d;

    checkPromise: any;
    checkPromiseResolve: any;
    checkData = false;
    checkEvent = false;
    exchangeRate = '6.87';

    cancelToken: any;
    aef: any;

    filters = {

    };

    @Prop({})
    poiData: any;
    get RightData () {
        if(qsObj.hoilday === 'true'){
            if(this.poiData.RightData && this.poiData.RightData.emotionComment){
                this.poiData.RightData.emotionComment.emotionMid = 0.12;
                this.poiData.RightData.emotionComment.emotionMidCount = 378;
                this.poiData.RightData.emotionComment.emotionNeg = 0.07;
                this.poiData.RightData.emotionComment.emotionNegCount = 220;
                this.poiData.RightData.emotionComment.emotionPos = 0.81;
                this.poiData.RightData.emotionComment.emotionPosCount = 2553;
            }
        }
        return this.poiData.RightData || {}
    }
    @Watch('RightData', {immediate: true})
    onRightData (RightData:any, oldVal: any) {
        if (RightData['名称']) {
            this.triggerAnimation('checkData');
            let starCnt: number = this.poiData.RightData['星级'] / 10;
            this.calcStar(starCnt);
        }
    }

    starCnt: any = 0;
    starFull: number = 0;
    starHalf: number = 0;
    starEmpty: number = 0;

    calcStar (starCnt) {
        this.starFull = parseInt('' + starCnt);
        let residue = starCnt - this.starFull;
        this.starHalf = (residue >= 0.3 || residue <= 0.9) ? 1 : 0;
        if (residue === 0) {
            this.starHalf = 0;
        }
        // this.starHalf = Math.round(starCnt) > starCnt ? 1 : 0;
        this.starEmpty = 5 - this.starFull - this.starHalf;
        this.starCnt = starCnt;
        console.log(this.starFull, this.starHalf, this.starEmpty, this.starCnt);
    }

    similarHandler (item) {
        let subjectId = item.mid;
        item.subjectId = item.mid;
        item.type = 'poi'; // 啊啊啊啊啊 不写会死循环啊
        SearchStore.addHistory(item);
        DetailStore.getPoiDataBySubjectId(subjectId);
        DetailStore.getPoiGraph({subjectId});
    }

    *actionScriptPoiRight(isQuick) {
        // 等待事件和数据的准备过程
        this.triggerAnimation('checkEvent');
        yield this.$sleep(0);
        yield this.checkPromise;

        yield this.$sleep(0); // why?

        if (isQuick) {
            this.animationBaseInfo = 'fly-in';
            this.animationEmotionEvaluate = 'fly-in';
            this.$bus.$emit('poi-right-pie');
            this.animationEmotionPos = 'fly-in';
            this.animationEmotionMid = 'fly-in';
            this.animationEmotionNeg = 'fly-in';
            this.animationEmotionAnalyze = 'fly-in';
            this.animationCommentCount = 'fly-in';
            this.animationSentimentAnalysis = 'fly-in';
            this.animationSamePoi = 'fly-in';
            this.animationSimilar = 'fly-in';
            this.$bus.$emit('poi-right-stack-area');
            // this.$bus.$emit('poi-right-area');
            this.$bus.$emit('poi-right-pictorialBar');
            return void 0;
        }

        // 基础信息面板
        this.animationBaseInfo = 'fly-in';
        // yield this.$onNativeOnce('this.$refs.baseInfo'); // 2000
        yield this.$sleep(300);

        // 情感评价面板
        this.animationEmotionEvaluate = 'fly-in';
        // yield this.$onNativeOnce('this.$refs.emotionEvaluate'); // 2000
        yield this.$sleep(300);

        // yield Promise.all([
        //     new Promise(async (resolve, reject) => {
        //         await this.$bus.$emit('poi-right-pie');
        //         resolve();
        //     }),
        //     (async () => {
        //         this.animationEmotionPos = 'fly-in';
        //         await this.$onNativeOnce('this.$refs.pos');
        //         this.animationEmotionMid = 'fly-in';
        //         await this.$onNativeOnce('this.$refs.mid');
        //         this.animationEmotionNeg = 'fly-in';
        //         await this.$onNativeOnce('this.$refs.neg');
        //     })()
        // ]);
        this.$bus.$emit('poi-right-pie');
        this.animationEmotionPos = 'fly-in';
        // yield this.$sleep(100);
        this.animationEmotionMid = 'fly-in';
        // yield this.$sleep(100);
        this.animationEmotionNeg = 'fly-in';
        // yield this.$sleep(100);

        // 情感分析面板
        this.animationEmotionAnalyze = 'fly-in';
        // yield this.$onNativeOnce('this.$refs.emotionAnalyze');
        yield this.$sleep(300);

        this.$bus.$emit('poi-right-stack-area');

        // 评价数量面板
        // this.animationCommentCount = 'fly-in';
        // 细粒度情感分析
        this.animationSentimentAnalysis = 'fly-in';
        // yield this.$onNativeOnce('this.$refs.commentCount');
        yield this.$sleep(300);

        // this.$bus.$emit('poi-right-area');
        this.$bus.$emit('poi-right-pictorialBar');


        // 相似餐厅面板
        this.animationSamePoi = 'fly-in';
        // yield this.$onNativeOnce('this.$refs.samePoi');
        yield this.$sleep(300);


        this.animationSimilar = 'fly-in';
        yield this.$sleep(2000);

        // 左侧树型信息
        if ($qsObj.quickall !== 'true') {
            yield this.$bus.$emit('poi-left-tree-animation');
        }
    }

    // 检查数据和时间是否都准备好了 这块的时序问题要好好处理下
    triggerAnimation (checkFlag) {
        this[checkFlag] = true;
        if (this.checkData && this.checkEvent) {
            this.checkPromiseResolve();
        }
    }

    created () {
        this.checkPromise = new Promise((resolve, reject) => this.checkPromiseResolve = resolve);
    }

    mounted () {
        console.log('mounted:PoiRightVue');
        this.cancelToken = new this.$ae.CancelToken();
        this.aef = this.$ae(this.actionScriptPoiRight, this.cancelToken);
        this.$autoOn('poi-right-start', this.aef);
        if ($qsObj.view === '2d') {
            if ($qsObj.auto === 'true') {

            }
        }
    }
}
